

const success = key => `${key}_SUCCESS`;
const failure = key => `${key}_FAILURE`;
const init = key => `${key}_INIT`;

export default {
    success,
    failure,
    init,
};



// WEBPACK FOOTER //
// ./src/client/utils/action-key.js